import React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Box from '@mui/material/Box';

export default function MealTag() {
  return (
    <>
    
    <Box component='container' backgroundColor="#2b817b" >

    <Box backgroundColor="#F0FAF9" sx={{display:'flex', flexDirection: 'row', height:"88px", alignItems: "center"}}>
        <Box  sx={{display: "flex", alignItems: "center", pr: "14px", pl: "18px"}}>
        <CheckCircleIcon sx={{color:"#42C677"}}/>
        </Box>

        <Box  mt="4px" width="100%">
        <Box>
        <Typography sx={{fontSize: {xl: "", lg: "18px", md: "18px", sm: "18px", xs: "18px"}, fontWeight: "600"}}>
        Arabian Kebab, Middle East..
        </Typography>
        </Box>

        <Box sx={{display: "flex",  justifyContent: "space-between",}}>
        <Box sx={{display: "flex", flexDirection: "row"}}>

        <Box pr="8px">
            <CalendarMonthIcon sx={{color: "#545359"}}/>
        </Box>
        <Box><Typography sx={{fontSize: {xl: "", lg: "16px", md: "16px", sm: "16px", xs: "16px"}, fontWeight: "400", lineHeight: "25.6px", color: "#545359", pr: "8px"}}>Monthly</Typography></Box>
        <Box>            
            <Typography sx={{fontSize: {xl: "", lg: "16px", md: "16px", sm: "16px", xs: "16px"}, fontWeight: "400", lineHeight: "25.6px", color: "#545359"}}>Dec, 15 2021 - Jan, 15 2022</Typography>
        </Box>
        </Box>

        <Box pr= "32px">
       <Link component= "button">
       <Typography  color="#2B817B">
        Hide
        </Typography>
        </Link>
        </Box>

        </Box>
        </Box>




    </Box>

    </Box>
    
    </>
  )
}
